module.exports = __webpack_public_path__ + "342ba3d8ac29ac8c38d7cef8efbf2dc9.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/media/fonts/Poppins/Poppins-SemiBold.ttf
// module id = 1262
// module chunks = 0